import request from '@/utils/request'
import store from '@/store'

const url = store.getters.getPostUrl;
export default {
  selectUserList(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/user/page',
      method: 'post',
      data:param
    })
  },
  insert(param) {
	  return request({
	    url: store.getters.getPostUrl + 'mes/user',
	    method: 'post',
	    data:param
	  })
  },
  update(id, param) {
  	  return request({
  	    url: store.getters.getPostUrl + 'mes/user/'+id,
  	    method: 'put',
  	    data:param
  	  })
  },
  del(param) {
  	  return request({
  	    url: store.getters.getPostUrl + 'mes/user',
  	    method: 'delete',
		data:param
  	  })
  },
  selectRoleList() {
	  return request({
	    url: store.getters.getPostUrl + 'mes/role/all',
	    method: 'get'
	  })
  },
  selectAllUserList(param) {
	  return request({
		url: store.getters.getPostUrl + 'mes/user/all',
		method: 'post',
		data:param
	  })
  },
  resetPassword(id) {
    return request({
      url: store.getters.getPostUrl + '/mes/user/password/' + id,
      method: 'get'
    })
  },
	getByName(param) {
	  return request({
	    url: store.getters.getPostUrl + '/mes/user/byName',
	    method: 'get',
		params:param
	  })
	},
}



// WEBPACK FOOTER //
// ./src/assets/js/user/user.js